import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AddCustomReportComponent } from "src/app/components/reports/custom-report/add/add.component";
import { EditCustomReportComponent } from "src/app/components/reports/custom-report/edit/edit.component";
import { ListCustomReportComponent } from "src/app/components/reports/custom-report/list/list.component";
import { ViewReportNewComponent } from "src/app/components/reports/report-new/view/view.component";
import { ListReportNewComponent } from "src/app/components/reports/report-new/list/list.component";
import { ReportComponent } from "src/app/components/reports/report.component";

const routes: Routes = [
    //{ path: 'reports', component: ReportComponent },
    //{ path: 'newreport/view/:id', component: ViewNewReportComponent },

    { path: '', component: ListReportNewComponent },
    { path: 'view/:id', component: ViewReportNewComponent },
    { path: 'customreports', component: ListCustomReportComponent },
    { path: 'customreports/add', component: AddCustomReportComponent },
    { path: 'customreports/edit/:id', component: EditCustomReportComponent },
]

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class ReportRoutingModule { }